
export const PhoneIcon = () => {
  return (
    <div className="contacts__icon">
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.1549 35C24.0251 35 22.9048 34.8003 21.8094 34.4023C16.9836 32.6492 12.5042 29.794 8.8553 26.1452C5.20643 22.4964 2.35117 18.0169 0.598168 13.191C0.0348418 11.6402 -0.131401 10.0393 0.104224 8.4326C0.324947 6.92767 0.907892 5.46668 1.7901 4.20755C2.67621 2.94289 3.85755 1.89102 5.20636 1.16568C6.64472 0.39223 8.21466 0 9.87272 0C10.3884 0 10.8341 0.360308 10.9422 0.864506L12.6589 8.87583C12.7366 9.2386 12.6251 9.61606 12.3628 9.87841L9.42943 12.8117C12.1966 18.3135 16.6868 22.8037 22.1886 25.5709L25.1219 22.6375C25.3843 22.3752 25.7618 22.2639 26.1245 22.3415L34.1358 24.0582C34.6401 24.1662 35.0003 24.6119 35.0003 25.1276C35.0003 26.7857 34.6081 28.3557 33.8346 29.794C33.1092 31.1428 32.0574 32.3242 30.7927 33.2103C29.5336 34.0925 28.0727 34.6754 26.5677 34.8962C26.0961 34.9654 25.6245 34.9999 25.1549 35ZM8.99885 2.23526C6.81178 2.4767 4.87059 3.62303 3.58152 5.46285C2.13195 7.53166 1.79393 10.0762 2.65413 12.4442C6.02438 21.722 13.2784 28.9761 22.5562 32.3463C24.9242 33.2065 27.4687 32.8686 29.5376 31.4189C31.3774 30.1299 32.5238 28.1887 32.7652 26.0016L26.248 24.6051L23.1845 27.6686C22.8586 27.9945 22.3632 28.0812 21.9461 27.8851C15.4393 24.8282 10.1723 19.5612 7.11535 13.0543C6.91937 12.6371 7.00591 12.1418 7.33191 11.8159L10.3954 8.75244L8.99885 2.23526Z"
          fill="white"
        />
      </svg>
    </div>
  )
}
